import React from '../../_snowpack/pkg/react.js';

function ChunkSlice({
  width,
  height
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.98 1L9.53 9.53A18.89 18.89 0 016 7.96C3 6.24 1.4 4.07 1 1.87L17.98 1z",
    fill: "#fff",
    stroke: "#828A90",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.98 1l-.03 9.25-8.45 8.52.03-9.24L17.98 1z",
    fill: "#fff",
    stroke: "#828A90",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.54 8.95l-5.61 5.66M10.93 12.71l5.62-5.65M10.94 10.82l5.61-5.66",
    stroke: "#828A90",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53 9.53v9.24a18.77 18.77 0 01-3.52-1.56c-3-1.73-4.61-3.9-5-6.09V1.87c.39 2.2 2 4.37 5 6.09a18.89 18.89 0 003.52 1.57z",
    fill: "#DAF5CB",
    stroke: "#828A90",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

ChunkSlice.defaultProps = {
  height: 20,
  width: 19
};
export default ChunkSlice;